import { Pipe, PipeTransform } from '@angular/core';
import { SerialEventsCount } from '../models/serialEventsCount.model';

@Pipe({ name: 'serialEvenstCount' })
export class SerialEvenstCountPipe implements PipeTransform {
  transform(
    event: string,
    date: string,
    serial: string,
    listEvents: SerialEventsCount[]
  ): string {
    if (!date || !event || !serial || !listEvents) {
      return '';
    }

    var filterEvent = listEvents.filter((item) => {
      return item.serial == serial && item.date == date && item.event == event;
    });
    if (filterEvent.length > 0) {
      return filterEvent[0].count.toString();
    } else {
      return '';
    }
  }
}
